export function resolveRedirectTarget(search: string): string {
  const raw = new URLSearchParams(search).get("redirect");
  // Only allow in-app absolute paths. "//" and "\" are protocol-relative in
  // browsers and would leave the app.
  if (
    !raw ||
    !raw.startsWith("/") ||
    raw.startsWith("//") ||
    raw.includes("\\")
  )
    return "/";
  return raw;
}
